import { loadScript } from '~/utils/globals.js';
import {
	getIframeLeftOffset,
	getIframeTopOffset,
	getOrientation,
	orientationChangeHandler
} from '~/components/casino-shared/game-loader/ducks/toolbar-utils';
import NLCPostMessages from './nlc-post-messages.js';

function load({ params, props, target, basePathname }) {
	return new Promise((resolve, reject) => {
		loadScript('//nolimitjs.nolimitcdn.com/dist/nolimit-latest.min.js')
			.then(() => {
				const { operator, language, environment, currency, game, token, extra, device, jurisdiction } = params;
				const { hasRegulationHeader, isDesktop, hasInGameMobileToolbar } = props;
				let arrangedTarget = target;

				if (device === 'mobile') {
					// creating a div container for NLC to fix orientation change issues
					const subTarget = document.createElement('div');
					target.appendChild(subTarget);
					arrangedTarget = subTarget;

					const leftOffset = getIframeLeftOffset(hasInGameMobileToolbar);
					const topOffset = getIframeTopOffset(hasRegulationHeader, hasInGameMobileToolbar);

					arrangedTarget.setAttribute(
						'style',
						`
					width: calc(100% - ${leftOffset} - env(safe-area-inset-right));
					height: calc(100% - ${topOffset});
					position: fixed;
					top: ${topOffset};
					left: ${leftOffset};
				`
					);

					const [, mediaQueryList] = getOrientation();

					const orientationChangeListener = orientationChangeHandler.bind(
						null,
						isDesktop,
						hasRegulationHeader,
						hasInGameMobileToolbar,
						arrangedTarget
					);

					mediaQueryList.addEventListener('change', orientationChangeListener);

					resolve(() => {
						mediaQueryList.removeEventListener('change', orientationChangeListener);
					});
				}

				const options = {
					operator,
					language,
					device,
					environment,
					currency,
					game,
					target: arrangedTarget,
					...(!!token && token.length ? { token } : {}),
					...(extra ? { extra: JSON.stringify(extra) } : {}),
					jurisdiction: {
						name: jurisdiction || ''
					},
					clock: jurisdiction !== 'SE',
					fullscreen: false
				};

				const api = window.nolimit.load(options);

				NLCPostMessages(api, basePathname);
			})
			.catch(reject);
	});
}

export default { load };
